import CompositeArrayNodeBase from '../../../../framework/oop/composite/CompositeArrayNodeBase';

import DatasetsLayoutNode from './DatasetsLayoutNode';
import DatasetsLayoutNodeVisitor from './DatasetsLayoutNodeVisitor';

/**
 * An element of a layout elements tree that represents a series of elements
 * stacked top to bottom.
 */
class VerticalStackLayoutNode
  extends CompositeArrayNodeBase<DatasetsLayoutNode>
  implements DatasetsLayoutNode
{
  public acceptVisitor(visitor: DatasetsLayoutNodeVisitor): void {
    visitor.visitVerticalStack(this);
  }
}

export default VerticalStackLayoutNode;
